'use client';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
// The two settings surfaces are disjoint: org settings always render as a full
// page (`OrgSettingsLayout`), personal account settings always render inside
// the hash-driven settings modal. The route registry is partitioned the same
// way so each surface only knows its own pages; `Exclude` keeps the partition
// exhaustive at compile time.
export const AccountPage = Dynamic(async () => {
    const { AccountPage } = await import('#pplx/frontend/apps/ask/page-components/account/index.js');
    return { default: AccountPage };
}, { critical: true });
//# sourceMappingURL=accountRouteMap.js.map